import { render } from "./AddMenuModifierItem.vue?vue&type=template&id=34f3fd2b&scoped=true"
import script from "./AddMenuModifierItem.vue?vue&type=script&lang=js"
export * from "./AddMenuModifierItem.vue?vue&type=script&lang=js"

import "./AddMenuModifierItem.vue?vue&type=style&index=0&id=34f3fd2b&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f3fd2b"]])

export default __exports__